module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/US-3c33de58872a541bf567973de1dc5635.png";